<div class="modal-header">
  <h2 class="modal-title">
    {{ 'sites.seasonality.popupConfirmation.title' | translate }}
  </h2>

  <button
    mat-icon-button
    type="button"
    class="close-button"
    (click)="close(false)"
    aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="modal-content">
  <p class="modal-text">
    {{ 'sites.seasonality.popupConfirmation.description' | translate }}
  </p>

  <p class="modal-text modal-text--strong">
    {{ 'sites.seasonality.popupConfirmation.pleaseConfirm' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button class="cancel-button" (click)="close(false)">
    {{ 'sites.seasonality.popupConfirmation.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ 'sites.seasonality.popupConfirmation.confirm' | translate }}
  </button>
</mat-dialog-actions>
